import { z } from 'zod';
/**
 * A comma-separated sort list, optionally prefixed per field with `-` for descending.
 *
 * The counterpart to {@link CursorPaginatedResponseSchema}: a house REST convention rather than any
 * one service's contract, so it lives beside the response envelope it pairs with.
 */
export const SORT_QUERY_PARAMETER_REGEX = /^(-?[a-z][A-Za-z0-9]*)(,-?[a-z][A-Za-z0-9]*)*$/;
const coerceQueryStringToNumber = (value) => {
    if (typeof value !== 'string' || value.trim() === '') {
        return value;
    }
    return Number(value);
};
const pageSizeSchema = z.preprocess(coerceQueryStringToNumber, z.number().min(1).max(500));
const pageFirstRequestSchema = z.object({ size: pageSizeSchema }).strict();
const pageAfterSchema = z
    .object({
    size: pageSizeSchema.optional().default(25),
    after: z.string(),
})
    .strict();
const pageSchema = z.union([pageFirstRequestSchema, pageAfterSchema]);
const sortSchema = z.string().regex(SORT_QUERY_PARAMETER_REGEX).optional();
/**
 * Adds optional cursor pagination and sort to a query schema, in the wire format Joi established:
 * a `page: { size, after }` object and a comma-separated `sort` string.
 *
 * One object with an optional `page`, rather than a union of paginated and unpaginated forms. A
 * query string is a flat set of parameters, and neither OpenAPI nor a generated client can express
 * "one of these two shapes": a union converts to `anyOf`, which publishes no parameters at all.
 *
 * Strictness is inherited rather than imposed, so extending a strict base stays strict and an
 * unknown key is rejected exactly where it was before.
 */
export function addOptionalCursorPaginationQuery(baseSchema) {
    return baseSchema.extend({ page: pageSchema.optional(), sort: sortSchema });
}
/** As {@link addOptionalCursorPaginationQuery}, for a handler that always paginates. */
export function addRequiredCursorPaginationQuery(baseSchema) {
    return baseSchema.extend({ page: pageSchema, sort: sortSchema }).strict();
}
//# sourceMappingURL=cursorPaginationQuery.js.map